<template>
  <div style="text-align: center">
    <a-spin :spinning="pageLoading">
      <div class="topbar">
        <!-- 左侧：版本选择 -->
        <div class="topbar-left">
          <span class="version-label">版本：</span>
          <a-dropdown>
            <template #overlay>
              <a-menu>
                <a-menu-item v-for="(label, code) in filteredVersionMap" :key="code" @click="changeVersion(code)">
                  {{ label }}
                </a-menu-item>
              </a-menu>
            </template>
            <a-button type="ghost" size="middle" class="version-selector">
              {{ versionMap[version] || version }}
              <DownOutlined />
            </a-button>
          </a-dropdown>
        </div>

        <!-- 中间：页面标题 -->
        <div class="topbar-title">
          <div class="title-cn">OH 社区运营平台</div>
        </div>

        <!-- 右侧：用户信息 -->
        <div class="topbar-right">
          <UserOutlined class="user-icon" />
          <span class="user-name">{{ user.name || 'Guest' }}</span>
          <a class="logout-btn" @click="handleLogout">
            <LogoutOutlined />
            <span class="logout-text">退出</span>
          </a>
        </div>
      </div>

      <div class="chart-wrapper">
        <a-spin :spinning="progressPieChartLoading">
          <div class="chart-title">当前版本需求进展</div>
          <ProgressPieChart :data="pieChartData" />
        </a-spin>
      </div>

      <div class="completion-bars">
        <a-spin :spinning="completionBarLoading">
          <div class="completion-bars-inner">
            <div v-for="(item, index) in completionBarData" :key="index" class="completion-bar-wrapper"
              style="margin-right: 16px;">
              <div class="chart-title">
                {{ PMCMap[item.project] || item.project }}
              </div>
              <div style="margin-top: 10px;">
                <a-tag v-if="item.riskLevel === 'High Risk'" color="red">高风险</a-tag>
                <a-tag v-else-if="item.riskLevel === 'Medium Risk'" color="orange">中风险</a-tag>
                <a-tag v-else-if="item.riskLevel === 'Low Risk'" color="green">低风险</a-tag>
                <a-tag v-else color="default">无需求</a-tag>
              </div>
              <div v-if="item.riskLevel !== null && item.riskLevel !== undefined">
                <CompletionBar :ratio="item.completedRatio" />
              </div>
            </div>
          </div>
        </a-spin>
      </div>

      <div class="add-button-container">
        <a-button type="dashed" class="add-button" @click="handleAdd">
          <PlusCircleOutlined />创建需求
        </a-button>
      </div>

      <a-spin :spinning="demandListLoading">
        <a-table :columns="columns" :data-source="demandList" :scroll="{ x: 1200, y: 400 }"
          :pagination="paginationConfig" @change="handleTableChange" class="demand-list" size="small">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'project'">
              {{ PMCMap[record.project] || record.project }}
            </template>
            <template v-else-if="column.key === 'status'">
              <a-tag :color="statusColorMap[record.status] || 'default'">
                {{ statusMap[record.status] || record.status }}
              </a-tag>
            </template>
            <template v-else-if="column.key === 'operation'">
              <div class="small-square-button-container">
                <a-tooltip title="需求详情">
                  <a-button class="small-square-button" @click="handleDetail(record, 'detail')">
                    <EyeTwoTone />
                  </a-button>
                </a-tooltip>
              </div>
              <div class="small-square-button-container">
                <a-tooltip title="编辑需求">
                  <a-button class="small-square-button" @click="handleDetail(record, 'edit')">
                    <EditTwoTone />
                  </a-button>
                </a-tooltip>
              </div>
              <div class="small-square-button-container">
                <a-tooltip title="取消需求">
                  <a-button class="small-square-button" @click="handleDelete(record)">
                    <DeleteTwoTone />
                  </a-button>
                </a-tooltip>
              </div>
              <div class="small-square-button-container">
                <a-tooltip title="锁定需求">
                  <a-button class="small-square-button" @click="handleDetail(record, 'lock')">
                    <LockTwoTone />
                  </a-button>
                </a-tooltip>
              </div>
              <div style="display: inline-flex;">
                <a-tooltip title="预承接需求">
                  <a-button class="small-square-button" @click="handleAccept(record)">
                    <CheckSquareTwoTone />
                  </a-button>
                </a-tooltip>
              </div>
            </template>
          </template>
        </a-table>
      </a-spin>
    </a-spin>
  </div>
</template>

<script>
import ProgressPieChart from './ProgressPieChart.vue';
import CompletionBar from './CompletionBar.vue';
import axios from 'axios';
import {
  DeleteTwoTone,
  EditTwoTone,
  EyeTwoTone,
  PlusCircleOutlined,
  CheckSquareTwoTone,
  LockTwoTone,
  DownOutlined,
  UserOutlined,
  ExclamationCircleOutlined,
  LogoutOutlined
} from '@ant-design/icons-vue';
import { createVNode } from 'vue';
import { Modal, notification } from 'ant-design-vue';
import openAtomApi from '@/openAtomApi';
import Cookies from 'js-cookie';

export default {
  components: {
    ProgressPieChart,
    CompletionBar,
    DeleteTwoTone,
    EditTwoTone,
    EyeTwoTone,
    PlusCircleOutlined,
    CheckSquareTwoTone,
    LockTwoTone,
    DownOutlined,
    UserOutlined,
    LogoutOutlined
  },
  data() {
    return {
      language: 'zh',
      user: {},
      version: "",
      versionMap: {},
      pieChartData: [],
      completionBarData: [],
      PMCMap: {},
      demandList: [],
      pageVO: {
        totalRows: 0,
        curPage: 1,
        pageSize: 10,
        startIndex: 0,
        endIndex: 0,
        totalPages: 0
      },
      statusMap: {},
      statusColorMap: {
        'R_PROPOSAL': '#7FB6FF',
        'R_COOPERATION': '#6EE7B7',
        'R_DEVELOPMENT': '#FFB57C',
        'R_TESTING': '#C7A5FF',
        'R_COMPLETION': '#4CAF50',
        'R_CANCELLATION': '#FF4D4F'
      },
      columns: [
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          fixed: 'left',
          width: 200,
          align: 'center',
        },
        {
          title: '需求编号',
          dataIndex: 'requestNumber',
          key: 'requestNumber',
          align: 'center',
          width: 150,
        },
        {
          title: '所属PMC',
          dataIndex: 'project',
          key: 'project',
          width: 180, ellipsis: true,
        },
        {
          title: '子项目',
          dataIndex: 'subProject',
          key: 'subProject',
          width: 200, ellipsis: true,
        },
        {
          title: '需求标题',
          dataIndex: 'title',
          key: 'title',
          width: 250, ellipsis: true,
        },
        {
          title: '工作量预估/人月',
          dataIndex: 'workload',
          key: 'workload',
          width: 120,
        },
        {
          title: '期望完成时间',
          dataIndex: 'estimatedDeliveryDate',
          key: 'estimatedDeliveryDate',
          width: 100, ellipsis: true,
        },
        {
          title: '需求负责人',
          dataIndex: 'owner',
          key: 'owner',
          width: 100, ellipsis: true,
        },
        {
          title: '当前状态',
          dataIndex: 'status',
          key: 'status',
          width: 75,
        },
        {
          title: '承接单位',
          dataIndex: 'undertakingPartnerName',
          key: 'undertakingPartnerName',
          width: 150, ellipsis: true,
        },
      ],
      pageLoading: true,
      progressPieChartLoading: false,
      completionBarLoading: false,
      demandListLoading: false,
    };
  },
  computed: {
    filteredVersionMap() {
      // Filter out current version from versionMap
      const filtered = {};
      for (const [code, label] of Object.entries(this.versionMap)) {
        if (code !== this.version) {
          filtered[code] = label;
        }
      }
      return filtered;
    },
    paginationConfig() {
      return {
        current: this.pageVO.curPage,
        pageSize: this.pageVO.pageSize,
        total: this.pageVO.totalRows,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total) => `共 ${total} 项`
      };
    }
  },
  async created() {
    this.authorize();
    try {
      await Promise.all([
        this.fetchLookupData('OP_PMC', this.PMCMap),
        this.fetchLookupData('OP_VERSION', this.versionMap),
        this.fetchLookupData('OP_RE_STATUS', this.statusMap)
      ]);
      this.pageLoading = false;
      await this.loadData(this.$route.params.version);
    } catch (error) {
      console.error(error);
      if (error.status === 403) {
        this.$router.push('/403');
      } else {
        this.$router.push('/500');
      }
    }
  },
  methods: {
    async authorize() {
      try {
        const openAtomRes = await openAtomApi.get('/user/info');
        this.user.login = openAtomRes.data?.login;
        this.user.id = openAtomRes.data?.id;
        this.user.name = openAtomRes.data?.name;
      } catch (error) {
        notification.error({
          message: '获取用户信息失败',
          description: error,
        });
      }
    },
    changeVersion(code) {
      window.location.href = `/demand-platform/home/${code}`;
    },
    async loadData(selectedVersion) {
      this.version = selectedVersion;
      await Promise.all([
        this.getPieChartData(),
        this.getCompletionBarData(),
        this.getDemandList()
      ]);
    },

    async fetchLookupData(lookupType, targetMap) {
      const res = await axios.post('/requestHeader/queryLookup', null, {
        params: {
          lookupType,
          lookupCode: '',
          language: this.language || 'zh'
        }
      });
      if (res.data.code !== 200) {
        throw new Error(res.data.desc);
      }
      const dataList = res.data.data || [];
      dataList.forEach(item => {
        targetMap[item.lookupCode] = item.lookupValue;
      });
    },

    async getPieChartData() {
      this.progressPieChartLoading = true;
      let demandTotalProgress = [];
      try {
        const res = await axios.get('/requestHeader/getDemandTotalProgressByVersion', {
          params: { version: this.version }
        });

        if (res.data.code !== 200) {
          throw new Error(res.data.desc);
        }

        demandTotalProgress = res.data.data;
      } catch (error) {
        notification.error({
          message: '获取需求总进展失败',
          description: error,
        });
      }

      const statusOrder = ['R_PROPOSAL', 'R_COOPERATION', 'R_DEVELOPMENT', 'R_TESTING', 'R_COMPLETION', 'R_CANCELLATION'];
      demandTotalProgress.sort((a, b) => {
        return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
      });

      const pieData = demandTotalProgress.map(item => ({
        name: this.statusMap[item.status],
        value: item.count,
        itemStyle: {
          color: this.statusColorMap[item.status]
        }
      }));
      this.pieChartData = pieData;
      this.progressPieChartLoading = false;
    },

    async getCompletionBarData() {
      this.completionBarLoading = true;
      try {
        const res = await axios.get('/requestHeader/getDemandCompletionRatioAndRiskLevelByVersionAndPMC', {
          params: {
            version: this.version,
            PMCList: Object.keys(this.PMCMap).join(',')
          }
        });

        if (res.data.code !== 200) {
          throw new Error(res.data.desc);
        }

        this.completionBarData = [];
        Object.keys(this.PMCMap).forEach(pmc => {
          const foundItem = res.data.data.find(item => item.project === pmc);
          if (foundItem) {
            this.completionBarData.push(foundItem);
          } else {
            this.completionBarData.push({
              project: pmc,
              completedRatio: null,
              riskLevel: ''
            });
          }
        });
      } catch (error) {
        notification.error({
          message: '获取各PMC需求进展失败',
          description: error,
        });
      }
      this.completionBarLoading = false;
    },

    handleTableChange(pagination) {
      this.pageVO.curPage = pagination.current;
      this.pageVO.pageSize = pagination.pageSize;
      this.getDemandList();
    },

    async getDemandList() {
      let data = [];
      this.demandListLoading = true;
      try {
        const res = await axios.get('/requestHeader/getDemandListByVersion', {
          params: {
            version: this.version,
            totalRows: this.pageVO.totalRows,
            curPage: this.pageVO.curPage,
            pageSize: this.pageVO.pageSize
          }
        });

        if (res.data.baseResult.code !== 200) {
          throw new Error(res.data.baseResult.desc);
        }
        data = res.data.baseResult.data;
        Object.assign(this.pageVO, res.data.pageVO);
      } catch (error) {
        notification.error({
          message: '获取需求列表失败',
          description: error,
        });
      }
      this.demandList = data.map(item => ({
        ...item,
        workload: parseFloat(item.workload),
      }));
      this.demandListLoading = false;
    },

    async checkPermission(operationCode, record, permissionMessage) {
      const AUTHORIZE_FORCE = false;
      if (AUTHORIZE_FORCE)
        return true;
      this.demandListLoading = true;
      try {
        const res = await axios.post('/requestHeader/checkPermissions', null, {
          params: {
            userId: this.user.id,
            opRequestHeaderId: record.opRequestHeaderId,
            operationCode
          }
        });
        this.demandListLoading = false;

        if (res.data.code !== 200) {
          throw new Error(res.data.desc);
        }

        if (!res.data.data) {
          throw new Error(permissionMessage); // 用传入的提示信息
        }

        return true;
      } catch (error) {
        this.demandListLoading = false;
        if (error.message.includes('权限')) {
          Modal.error({ content: error.message });
        } else {
          notification.error({
            message: '权限检查失败',
            description: error.message,
          });
        }
        return false;
      }
    },

    async handleDelete(record) {
      console.log('Delete clicked for record:', record);
      const permitted = await this.checkPermission('DELETE', record, '您没有权限取消该需求。');
      if (!permitted)
        return;
      const loadData = () => { this.loadData(this.version); };
      Modal.confirm({
        title: '确定要取消这项需求吗？',
        icon: createVNode(ExclamationCircleOutlined),
        content: '需求标题：' + record.title,
        okText: '取消需求',
        cancelText: '返回',
        okType: 'danger',
        async onOk() {
          try {
            const res = await axios.get('/requestHeader/cancelDemand', {
              params: { opRequestHeaderId: record.opRequestHeaderId }
            });
            if (res.data.code !== 200) {
              throw new Error(res.data.desc);
            }
            notification.success({
              message: '需求已取消',
              description: `需求 ${record.title} 已成功取消。`,
            });
            loadData();
          } catch (error) {
            notification.error({
              message: '取消需求失败',
              description: error,
            });
          }
        },
        onCancel() { },
      });
    },

    async handleAccept(record) {
      console.log('Accept clicked for record:', record);
      const permitted = await this.checkPermission('RECEIVE', record, '您没有权限预承接该需求。');
      if (!permitted)
        return;
      const loadData = () => { this.loadData(this.version); };
      const userId = this.user.id;
      Modal.confirm({
        title: '预承接后不可取消，请确认是否继续？',
        icon: createVNode(ExclamationCircleOutlined),
        content: '需求标题：' + record.title,
        okText: '确认',
        cancelText: '取消',
        async onOk() {
          try {
            const res = await axios.post('/requestHeader/preAcceptDemand', null, {
              params: {
                userId,
                opRequestHeaderId: record.opRequestHeaderId
              }
            });
            if (res.data.code !== 200) {
              throw new Error(res.data.desc);
            }
            notification.success({
              message: '需求已预承接',
              description: `需求 ${record.title} 已成功预承接。`,
            });
            loadData();
          } catch (error) {
            notification.error({
              message: '预承接需求失败',
              description: error,
            });
          }
        },
        onCancel() { },
      });
    },

    handleDetail(record, opetaionCode) {
      this.$router.push(`/demand-platform/detail/${record.opRequestHeaderId}/${opetaionCode}`);
    },

    handleAdd() {
      this.$router.push(`/demand-platform/detail/-1/add`);
    },

    handleLogout() {
      // localStorage.removeItem('accessToken');
      // localStorage.removeItem('refreshToken');
      Cookies.remove('accessToken', { path: '/' });
      Cookies.remove('refreshToken', { path: '/' });
      localStorage.removeItem('token_timestamp');
      window.location.href = '/login';
    }
  }
}
</script>

<style>
.add-button {
  height: 35px;
  width: 120px;
  font-weight: 600;
  font-size: 14px;
  color: white;
  background: linear-gradient(135deg, #4096ff 0%, #1890ff 100%);
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(64, 150, 255, 0.3);
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.3px;
}

.add-button:hover {
  background: linear-gradient(135deg, #3078e0 0%, #0d75d4 100%);
  box-shadow: 0 6px 16px rgba(64, 150, 255, 0.4);
  transform: translateY(-2px);
}

.add-button-container {
  display: block;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 0 50px;
}

.chart-wrapper {
  height: 250px;
  width: 30%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid #e0e6ef;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
  box-shadow: 0 6px 18px rgba(11, 23, 39, 0.05);
  transition: all 0.3s ease;
  overflow-x: auto;
  padding: 20px;
  margin-right: 24px;
}

.chart-wrapper:hover {
  box-shadow: 0 8px 24px rgba(11, 23, 39, 0.1);
  transform: translateY(-2px);
}

.completion-bars {
  display: inline-block;
  height: 250px;
  width: 65%;
  vertical-align: top;
  border: 1px solid #e0e6ef;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
  box-shadow: 0 6px 18px rgba(11, 23, 39, 0.05);
  transition: all 0.3s ease;
  overflow-x: auto;
  padding: 20px;
  gap: 16px;
}

.completion-bars:hover {
  box-shadow: 0 8px 24px rgba(11, 23, 39, 0.1);
  transform: translateY(-2px);
}

.completion-bars-inner {
  display: flex;
  justify-content: space-evenly;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a365d;
  margin-bottom: 12px;
  align-items: center;
  gap: 8px;
}

.completion-bar-wrapper {
  display: inline-block;
  width: 200px;
  margin-right: 16px;
}

.demand-list {
  margin: 0 50px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  background: #fff;
}

.demand-list .ant-table {
  border: none;
  border-radius: 0;
  overflow: hidden;
}

.demand-list .ant-table-thead>tr>th {
  font-weight: 600;
  color: #1a202c;
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.demand-list .ant-table-tbody>tr {
  border-bottom: 1px solid #e2e8f0;
}

.demand-list .ant-table-tbody>tr:hover>td {
  background: #f0f7ff !important;
  transition: background 0.2s ease;
}

.demand-list .ant-table-tbody>tr:last-child {
  border-bottom: none;
}

.demand-list .ant-table-tbody>tr>td {
  padding: 12px 16px;
  color: #4a5568;
  border: none;
}

.demand-list .ant-table-column-sorter {
  display: flex;
  align-items: center;
  gap: 4px;
}

.demand-list .ant-table-column-title {
  font-weight: 600;
  color: #1a202c;
}

.small-square-button {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: #f0f5ff;
  color: #1890ff;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.small-square-button:hover {
  background: #e6f0ff;
  color: #0d75d4;
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
}

.small-square-button-container {
  display: inline-flex;
  margin-right: 8px;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 32px;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #e0e6ef;
  transition: all 0.3s ease;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.version-label {
  font-size: 15px;
  font-weight: 600;
  color: #434343;
}

.version-selector {
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1890ff;
  border: 1px solid #d0e0ff;
  background: linear-gradient(135deg, #f0f5ff 0%, #e6f0ff 100%);
  height: 36px;
  min-width: 120px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.15);
  cursor: pointer;
}

.version-selector:hover {
  background: linear-gradient(135deg, #e6f0ff 0%, #d9e7ff 100%);
  border-color: #a5c8ff;
  box-shadow: 0 4px 10px rgba(24, 144, 255, 0.25);
}

.topbar-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.title-cn {
  font-size: 18px;
  color: #0a2463;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  margin: 0 8px;
  color: #b0b0b0;
  font-weight: 500;
  font-size: 14px;
}

.title-en {
  font-size: 14px;
  color: #595959;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-icon {
  font-size: 18px;
  color: #555;
}

.user-name {
  font-size: 14px;
  color: #333;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #999;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s;
}

.logout-btn:hover {
  color: #ff4d4f;
  /* Ant Design 的错误色，表示危险操作 */
}
</style>
